<template>
	<el-button :class="{'button' : !noStyle, 'button--no-style': noStyle}" @click="handleClick">
		<span v-if="$slots.icon" class="button__icon"><slot name="icon" /></span>
		<span v-if="!noStyle" class="button__text"><slot></slot></span>
		<slot v-else />
		<span v-if="$slots.icon2" class="button__icon"><slot name="icon2" /></span>
		<template><slot name="status-icon" /></template>
	</el-button>
</template>

<script>
	import Vue from 'vue';
	import { Button } from '@cognitoforms/element-ui';
	Vue.use(Button);

	export default {
		name: 'CButton',
		props: {
			noStyle: {
				default: false,
				type: Boolean
			}
		},
		methods: {
			handleClick: function (event) {
				this.$emit('click', event);
			}
		}
	};
</script>